<template>
    <div class="user-mes">
        <ul class="list-item items-st">
            <li class="list-items-ele" v-text="shareT" @click="openD()"></li>
            <li class="list-items-ele" v-text="shareAT" @click="openA()"></li>
            <li class="list-items-ele cle" v-for="(item,index) in list" :key="index">
                <div :title="item.num" v-text="item.num" class="lists-items fl"></div>
                <div class="lists-items fl" :title="item.shareState" v-text="item.shareState"></div>
                <button class="user-mes-btn fl" @click="cancleShare(item.ch)" :title="closeShare" v-text="closeShare" :disabled="item.shareStates===0"></button>
                <button class="user-mes-btns fl" @click="open(index)" :title="config" v-text="config"></button>
            </li>
        </ul>
    </div>
</template>
<script>
import share from '../assets/js/share'
export default {
    name:'ShareToFriend',
    props:['mes'],
    data(){
        return{
            shareT:this.lanNow.lan["K221_Share"],
            shareAT:this.lanNow.lan["K222_ShareAll"],
            shareCh:this.lanNow.lan["K223_Channel"],
            shared:this.lanNow.lan["K224_Shared"],
            noShared:this.lanNow.lan["K225_NoShare"],
            closeShare:this.lanNow.lan["K139_cancelShare"],
            config:this.lanNow.lan["K226_Config"],
            shareDA:[],
            list:[]
        }
    },
    methods:{
        open:function(index){
            this.$emit('setConfig',this.list[index]);
        },
        openD:function(){
            if(this.shareDA.length===0){
                return false;
            };
            var obj={
                ch:this.shareDA.join(','),
                id:this.mes.id,
                isHs:this.mes.isHs,
                name:this.mes.name,
                account:this.mes.account,
                accountId:this.mes.accountId,
                power:'1,3,4',
                weekdays:'0,1,2,3,4,5,6',
                periods:'00:00:00-23:59:59'
            };
            this.$emit('setConfig',obj);
        },
        openA:function(){
            var str=[];
            this.list.forEach(function(v){
                str.push(v.ch);
            });
            var obj={
                ch:str.join(','),
                id:this.mes.id,
                isHs:this.mes.isHs,
                name:this.mes.name,
                account:this.mes.account,
                accountId:this.mes.accountId,
                power:'1,3,4',
                weekdays:'0,1,2,3,4,5,6',
                periods:'00:00:00-23:59:59'
            };
            this.$emit('setConfig',obj);
        },
        cancleShare:function(ch){
            var arr=[];
            this.list.forEach(function(v,i){
                if(v.shareStates===1&&v.ch!==ch){
                    arr.push({
                        ch:v.ch,
                        id:this.mes.id,
                        isHs:this.mes.isHs,
                        name:this.mes.name,
                        account:this.mes.account,
                        accountId:this.mes.accountId,
                        power:v.power,
                        weekdays:v.weekdays,
                        periods:v.periods
                    });
                };
            }.bind(this));
            this.$emit('setCancel',arr,this.mes.accountId,this.mes.id);
        }
    },
    watch:{
        mes:{
            handler(newName, oldName) {
                var arr=[];
                this.shareDA=[];
                if(this.mes.default){
                    for(var i=0;i<this.mes.total.length;i++){
                        arr.push({
                            num:this.shareCh+'-'+this.mes.total[i],
                            ch:this.mes.total[i],
                            index:i,
                            id:this.mes.id,
                            isHs:this.mes.isHs,
                            name:this.mes.name,
                            account:this.mes.account,
                            accountId:this.mes.accountId,
                            power:this.mes.power,
                            weekdays:this.mes.weekdays,
                            periods:this.mes.periods,
                            default:this.mes.default,
                            shareState:this.mes.shared?this.shared:this.noShared,
                            shareStates:this.mes.shared?1:0
                        });
                    };
                }else{
                    for(var i=0;i<this.mes.total.length;i++){
                        arr.push({
                            num:this.shareCh+'-'+this.mes.total[i],
                            ch:this.mes.total[i],
                            index:i,
                            id:this.mes.id,
                            isHs:this.mes.isHs,
                            name:this.mes.name,
                            account:this.mes.account,
                            accountId:this.mes.accountId,
                            power:this.mes.power,
                            weekdays:this.mes.weekdays,
                            periods:this.mes.periods,
                            default:this.mes.default,
                            shareState:this.noShared,
                            shareStates:0
                        });
                    };
                    $(this.mes.sub).find('item').each(function(i,el){
                        var chn=(/\d+/).exec($(el).find('subcode').text())[0]-0;
                        var j=$.inArray(chn,this.mes.total);
                        arr[j].power=$(el).find('powers').text();
                        arr[j].weekdays=$(el).find('weekdays').text();
                        arr[j].periods=$(el).find('periods').text();
                        arr[j].shareState=this.shared;
                        arr[j].shareStates=1;
                        this.shareDA.push(arr[j].ch);
                    }.bind(this));
                    
                };
                this.list=arr;
            },
            immediate: false,
            deep: true
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:540px;
        height:400px;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        left:50%;
        margin-top:160px;
        margin-left:-240px;
        overflow:auto;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:300px;
        padding:20px;
        box-sizing: border-box;
        overflow:hidden;
        overflow-y: auto;
    }
    .mes-tips{
        width:100%;
        height:30px;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .mes-list-box{
        width:100%;
        height:calc(100% - 30px - 40px);
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    .mes-list-box-add{
        width:100%;
        height:calc(100% - 30px - 40px - 40px);
        border: 1px solid #ccc;
        box-sizing: border-box;
        margin-top:10px;
    }
    .list-item{
        width:100%;
        height:30px;
    }
    .lists-items{
        width:80px;
        height:100%;
        line-height:30px;
        border: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        box-sizing: border-box;
    }
    .list-items .list-items-1:first-child{
        border-left: none;
    }
    .list-items .list-items-1:last-child{
        width:calc(100% - 4 * 99px);
    }
    .list-items-ele{
        width:100%;
        height:100%;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        box-sizing: border-box;
        cursor: default;
    }
    .list-items-ele+.list-items-ele{
        margin-top: 10px;
    }
    .list-items .list-items-2:first-child{
        border-left: none;
    }
    .list-items .list-items-2:last-child{
        width:calc(100% - 248px);
    }
    .mes-list{
        width:100%;
        height:calc(100% - 30px);
        overflow: hidden;
        overflow-y: auto;
    }
    .mes-list .list-items{
        background-color: transparent;
        color:#000;
    }
    .list-items img{
        width:18px;
        height:18px;
        margin-top:4px;
        cursor: pointer;
    }
    .share-in{
        width:100%;
        height:30px;
    }
    .user-mes-inp{
        width:calc(100% - 100px);
        height:100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .share-input-search{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    .user-mes-btn{
        width:84px;
        height:30px;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    .user-mes-btns{
        width:60px;
        height:30px;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
        margin-left:20px;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>


// WEBPACK FOOTER //
// src/components/shareChild.vue